import { pushToDataLayerSitechromeWrapper as pushToDataLayer } from "@asosteam/asos-web-datalayer";

export const triggerExperimentEvent = (key, variation) => {
  if (typeof key !== "string") {
    return;
  }

  pushToDataLayer({
    experiment_activation: {
      experiments: [
        {
          key,
          variation: String(variation)
        }
      ]
    }
  });
};
